export class FlexLayoutUnit {
	value: number;
	units: string;
	public toString = (): string => this.value + this.units;

	constructor(value: number, units: string) {
		this.value = value;
		this.units = units;
	}
}

/* eslint-disable @typescript-eslint/no-namespace */
export namespace FlexLayoutType {
	export class Column {
		public static Full = new FlexLayoutUnit(100, '');
		public static Half = new FlexLayoutUnit(Column.Full.value / 2, '');

		public static Small = new FlexLayoutUnit(Column.Full.value / 4, '');
		public static Medium = new FlexLayoutUnit(Column.Full.value / 3, '');
		public static Large = new FlexLayoutUnit((Column.Full.value / 3) * 2, '');
	}

	export class Field {
		public static Small = new FlexLayoutUnit(275, 'px');
		public static Medium = new FlexLayoutUnit(Field.Small.value * 2, 'px');
		public static Large = new FlexLayoutUnit(Field.Small.value * 3, 'px');
	}

	export class Gap {
		public static Button = new FlexLayoutUnit(1, 'rem');
		public static Column = new FlexLayoutUnit(1, 'rem');

		public static XSmall = new FlexLayoutUnit(0.5, 'rem');
		public static XXSmall = new FlexLayoutUnit(0.2, 'rem');
		public static Small = new FlexLayoutUnit(1, 'rem');
		public static Medium = new FlexLayoutUnit(Gap.Small.value * 2, 'rem');
		public static Large = new FlexLayoutUnit(Gap.Small.value * 3, 'rem');
	}
}
